import { render, staticRenderFns } from "./actor-overview.vue?vue&type=template&id=3c6d1722&scoped=true&"
import script from "./actor-overview.vue?vue&type=script&lang=ts&"
export * from "./actor-overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d1722",
  null
  
)

export default component.exports